import { useNavigate } from '@tanstack/react-router'
import { useState } from 'react'

import { login } from '@/services/users'

import { formFor } from '@/libraries/forms'
import { ErrorMessage } from '@/libraries/forms/validation'
import { Button } from '@/libraries/ui'
import { useT } from '@/i18n'

export interface LoginFields {
  username: string
  password: string
}

const { Form, Input } = formFor<LoginFields>()

export function LoginForm({ redirectTo, defaultRedirectTo, onSuccess }: { redirectTo?: string, defaultRedirectTo?: string, onSuccess?: () => void }) {
  const [value, setValue] = useState<LoginFields>({ username: '', password: '' })
  const [error, setError] = useState<string | null>(null)
  const navigate = useNavigate()
  const t = useT('components.loginForm')

  const onSubmit = async ({ username, password }: LoginFields) => {
    const user = await login(username, password)
    if (!user) {
      setError(t('invalidCredentials'))
      return
    }
    onSuccess?.()
    const target = redirectTo ?? new URLSearchParams(window.location.search).get('redirectTo') ?? defaultRedirectTo
    if (target) navigate({ to: target })
  }

  return <Form value={value} onChange={setValue} onSubmit={onSubmit} errorDisplay="onSubmit">
    {error && <ErrorMessage error={{ errors: [error] }} />}
    <div className="flex gap-3">
      <Input path="username" label={t('username')} required />
      <Input path="password" label={t('password')} required componentProps={{ type: 'password' }} />
    </div>
    <Button color="primary" type="submit" text={t('login')} />
  </Form>
}

export default LoginForm
